jQuery(document).ready(function($) {
  var accordion = {
    accordionGroupClass: '.js-product-accordion-group',
    triggerClass: '.js-accordion-trigger',
    accordionClass: '.js-accordion',
    contentClass: '.js-accordion-content',
    scrollToContent(accordion) {
      setTimeout(function() {
        $('html, body').animate({
          scrollTop: accordion.offset().top
        }, 600, 'swing');
        return false;
      }, 320);

      // Prevent scrollTop from messing up user scrolling
      $(window).bind('mousewheel', function() {
        $('html, body').stop();
      });
    },
    closeAccordion(currentTrigger) {
      var accordion = $(this.accordionClass),
          content = accordion.children(this.contentClass),
          currentAccordion = currentTrigger.parent(this.accordionClass),
          currentContent = currentAccordion.children(this.contentClass);

      accordion.removeClass('is-open');
      content.velocity('slideUp', {duration: 300, easing: 'ease'});

    },
    openAccordion(currentTrigger) {
      var currentAccordion = currentTrigger.parent(this.accordionClass),
          currentContent = currentAccordion.children(this.contentClass),
          accordion = $(this.accordionClass),
          content = accordion.children(this.contentClass);

      // Close the content when clicking another accordion trigger
      // if there's already one open
      accordion.removeClass('is-open');
      content.velocity('slideUp', {duration: 300, easing: 'ease'});

      currentAccordion.addClass('is-open');
      currentContent.velocity('slideDown', {duration: 200, easing: 'ease'});

      // this.scrollToContent(currentTrigger);

    },
    handleClick(currentTrigger) {
      // Close the current accordion if it's open
      if(currentTrigger.parent(this.accordionClass).hasClass('is-open')) {
        this.closeAccordion(currentTrigger);

        // Prevent further code from executing
        return false;
      };
      // Open the accordion
      this.openAccordion(currentTrigger);
    },
    init() {
      var self = this;
      var accordionGroup = $(this.accordionGroupClass);
      $(this.triggerClass).on('click', function(event) {
        event.stopPropagation();
        var currentTrigger = $(this);
        self.handleClick(currentTrigger);
      });
//       var firstAccordion = accordionGroup.find(this.accordionClass + ':first').children(this.triggerClass);
//       this.openAccordion(firstAccordion);
    }
  };

  accordion.init();

  var productDescriptionAccordion = {
    accordionGroupClass: '.js-product-accordion-group',
    destinationClass: '.js-product-accordion',
    moveAccordion() {
      // Move the product accordion outside the description
      // (Below the add to cart button and stuff)
      var accordionGroup = $(this.accordionGroupClass);
      var destination = $(this.destinationClass);
      accordionGroup.appendTo(this.destinationClass);
      accordionGroup.addClass('is-visible');
    },
    init() {
      var accordionGroup = $(this.accordionGroupClass);
      if(accordionGroup.length > 0) {
        this.moveAccordion();
      }
    }
  };

  productDescriptionAccordion.init();
  
  $(document).ajaxComplete(function() {
    productDescriptionAccordion.init();
  });
});